export const empresas = [
    { id: 2, empresa: 'ECO SETTA ENERGIA' },
    { id: 3, empresa: 'SETTA GERACAO DE ENERGIA ELETRICA LTDA' },
    { id: 4, empresa: 'SETTA LOCACAO DE GERADOR FOTOVOLTAICO LTDA' },
    { id: 5, empresa: 'VILA INAJA ENERGIA SPE LTDA' },
    { id: 7, empresa: 'ECO BRASIL ENERGIA LTDA' },
    { id: 8, empresa: 'UFV PE INAJA LTDA' },
    { id: 9, empresa: 'VILA PERNAMBUCO ENERGIA S.A' },
    { id: 10, empresa: 'VILA PERNAMBUCO ENERGIA 2 S.A' },
    { id: 11, empresa: 'SETTA GERACAO PERNAMBUCO 1 S.A' },
    { id: 12, empresa: 'SETTA GERACAO PERNAMBUCO 2 S.A' },
    { id: 13, empresa: 'SETTA GERACAO 5 S.A' },
    { id: 14, empresa: 'COMPLEXO UFV IBIMIRIM SPE LTDA' },
    { id: 15, empresa: 'SETTA GERACAO 3 S.A' },
    { id: 16, empresa: 'SETTA GERACAO 4 S.A' },
    { id: 17, empresa: 'SETTA GERACAO 6 S.A' },
    { id: 18, empresa: 'SETTA GERACAO 7 S.A' },
    { id: 19, empresa: 'SETTA GERACAO 8 S.A' }
];
